/**
 * Route copy for `src/routes/sign` (keys: `routes.sign.<file>.<key>`).
 *
 * `fr` is the source; `en` and `ar` are typed against it, so a missing or extra
 * key fails `tsc` (and parity.test.ts). Keys are referenced from the route files
 * through `t()` / `tr()` — edit values freely, never rename a key without its call site.
 *
 * Locale file: en (typed against ./fr). One file per locale so
 * every non-default locale is a separate, lazily-loaded chunk.
 */

import type { Catalog } from './fr';

const en: Catalog = {
  publicSignPage: {
    quote: 'Quote',
    draft: 'Draft',
    awaitingSignature: 'Awaiting signature',
    accepted: 'Accepted',
    declined: 'Declined',
    poweredByKarexia: 'Powered by Karexia ·',
    privacyPolicy: 'Privacy policy',
    description: 'Description',
    qty: 'Qty',
    unitPrice: 'Unit price',
    tax: 'Tax',
    amount: 'Amount',
    subtotal: 'Subtotal',
    taxes: 'Taxes',
    discount: 'Discount',
    total: 'Total',
    notes: 'Notes',
    thisDocumentIsTemporarilyUnavailableTry: 'This document is temporarily unavailable. Try again.',
    pleaseEnterYourFullNameTo: 'Please enter your full name to sign.',
    thisDocumentHasAlreadyBeenAccepted: 'This document has already been accepted.',
    thisDocumentIsNoLongerOpen: 'This document is no longer open for signature.',
    savingFailedCheckYourInformationAnd: 'Saving failed. Check your information and try again.',
    loadingTheDocument: 'Loading the document…',
    documentNotFound: 'Document not found',
    thisSigningLinkIsInvalidOr: 'This signing link is invalid or no longer active. Contact the person who sent it to you to get a new one.',
    documentTemporarilyUnavailable: 'Document temporarily unavailable',
    anErrorOccurred: 'An error occurred.',
    tryAgain: 'Try again',
    documentReference: 'Document reference',
    refId: 'Ref. {{id}}',
    printOrSaveAsPdf: 'Print or save as PDF',
    printPdf: 'Print / PDF',
    documentAccepted: 'Document accepted',
    thankYouYourAcceptanceHasBeen: 'Thank you — your acceptance has been recorded. The person who sent you this {{v}} has been notified. Keep a copy: “Print / PDF” above.',
    documentDeclined: 'Document declined',
    yourRefusalHasBeenRecordedNo: 'Your refusal has been recorded. No further action is required from you.',
    signThisDocument: 'Sign this document',
    enterYourFullNameBelowIt: 'Enter your full name below; it serves as your signature.',
    fullName: 'Full name',
    janeDoe: 'Jane Doe',
    emailOptional: 'Email (optional)',
    saving: 'Saving…',
    accept: 'Accept',
    deny: 'Deny',
    yourNameYourEmailIfProvided: 'Your name, your email (if provided) and the connection\'s IP address are kept as proof of acceptance, in accordance with the',
    privacyPolicy2: 'privacy policy',
    thisDocumentIsNotOpenFor: 'This document is not open for signature at the moment.',
    proposal: 'Proposal',
  },
};

export default en;
